import { computed, defineComponent, getCurrentInstance, toRefs } from "@vue/composition-api";
import { ACCOUNT_PLAN_PAGE } from "@Broker/@Utils/enum";
import PlanTooltip from "@Broker/@Modules/account-plan/components/account-plan-usage/plan-tooltip.vue";
import * as AccountPlanGetters from "@Broker/@Modules/account-plan/store/account-plan-getters";
import { useAccountPlanStoreGetters } from "@Broker/@Modules/account-plan/store/account-plan-helpers";
import { useAutomationStoreGetters } from "../../../store/automation-helpers";
import * as AutomationGetters from "../../../store/automation-getters";
import { capitalize } from "@Shared/@Utils/helpers/text";
export default defineComponent({
  name: "DocumentAutomationRequestHeader",
  components: {
    PlanTooltip
  },
  props: {
    automation: {
      type: Object,
      required: true
    },
    toggleLoading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const internalInstance = getCurrentInstance();
    const {
      toggleLoading
    } = toRefs(props);
    const {
      title,
      description,
      active
    } = toRefs(props.automation);
    const currentPagePlan = ACCOUNT_PLAN_PAGE.DOCUMENT_REQUEST_RULE;
    const {
      IS_USAGE_RESTRICTED
    } = useAccountPlanStoreGetters([AccountPlanGetters.IS_USAGE_RESTRICTED]);
    const computedActive = computed({
      get() {
        return active.value;
      },
      set(value) {
        emit("toggle-active", value);
      }
    });
    const disableActiveToggle = computed(() => {
      if (IS_USAGE_RESTRICTED.value(currentPagePlan)) {
        return !computedActive.value;
      }
      return toggleLoading.value;
    });
    const {
      IS_DOCUMENT_REQUEST_EDIT_MODE,
      DOCUMENT_REQUEST_RULE_HAS_DOCUMENTS
    } = useAutomationStoreGetters([AutomationGetters.IS_DOCUMENT_REQUEST_EDIT_MODE, AutomationGetters.DOCUMENT_REQUEST_RULE_HAS_DOCUMENTS]);
    const isDocumentRequestEditMode = computed(() => IS_DOCUMENT_REQUEST_EDIT_MODE.value(props.automation.id));
    const documentRequestHasDocuments = computed(() => DOCUMENT_REQUEST_RULE_HAS_DOCUMENTS.value(props.automation.id));
    const editDescriptionText = computed(() => {
      if (isDocumentRequestEditMode.value) {
        return internalInstance == null ? void 0 : internalInstance.proxy.$t("global.words.done");
      }
      return capitalize(!documentRequestHasDocuments.value ? internalInstance == null ? void 0 : internalInstance.proxy.$t("global.words.add") : internalInstance == null ? void 0 : internalInstance.proxy.$t("global.words.edit"));
    });
    return {
      title,
      description,
      active,
      computedActive,
      currentPagePlan,
      disableActiveToggle,
      editDescriptionText,
      isDocumentRequestEditMode,
      documentRequestHasDocuments
    };
  }
});